import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private isHelpCenterOpenSubject: BehaviorSubject<boolean>;
  private areNotificationsOpenSubject: BehaviorSubject<boolean>;

  public isHelpCenterOpen$: Observable<boolean>;
  public areNotificationsOpen$: Observable<boolean>;

  constructor() {
    this.isHelpCenterOpenSubject = new BehaviorSubject<boolean>(false);
    this.areNotificationsOpenSubject = new BehaviorSubject<boolean>(false);

    this.isHelpCenterOpen$ = this.isHelpCenterOpenSubject.asObservable();
    this.areNotificationsOpen$ = this.areNotificationsOpenSubject.asObservable();
  }

  public toggleHelpCenter(isOpen: boolean): void {
    this.isHelpCenterOpenSubject.next(isOpen);
  }

  public toggleNotifications(isOpen: boolean): void {
    this.areNotificationsOpenSubject.next(isOpen);
  }
}
